import React, { useEffect, useRef, useState } from 'react'

import { useFilter } from '../../forms/hocs/filter.context.hoc'

import { FilterComponentProp } from '../../forms/hocs/types'
import { FilterName } from '../../__generated__/fed-graphql-types'
import {
    StyledLabelAndIconContainer,
    StyledSearchFilterDescription,
    StyledSearchFilterSelect,
    StyledSearchFilterSelectLabel,
    StyledSearchFilterSelectLabelCount,
    StyledSelectionContainer,
    StyledCheckBoxElement,
    StyledColourIcon,
} from './search-filters-checkbox.styles'
import { getColourGradient } from './search-filters-checkbox.utils'

export const SearchFiltersCheckbox = ({ option, overrideValue, invertColours }: FilterComponentProp) => {
    const { filterName, options, title, selected, hideCount, onValueChanged } = useFilter()
    const value = overrideValue || (option || options[0])?.value
    const count = (option || options[0])?.count
    const [isChecked, setIsChecked] = useState(selected.includes(value as string))
    const checkboxRef = useRef<HTMLInputElement | null>(null)
    const name = `${filterName}-${option?.label?.toLowerCase().replace(/\s/g, '_')}`

    const isColourFilter = filterName === FilterName.colour
    const colourGradient = isColourFilter ? getColourGradient(value as string) : ''

    useEffect(() => {
        if (Array.isArray(value)) {
            setIsChecked(value.some((val) => selected.includes(val)))
        } else {
            setIsChecked(selected.includes(value))
        }
    }, [selected, setIsChecked, value])

    function handleChangeEvent(checked: boolean) {
        setIsChecked(checked)
        const valuesWithoutCurrent = Array.isArray(value)
            ? selected.filter((item) => !value.includes(item))
            : selected.filter((item) => item != value)
        if (checked) {
            onValueChanged([...valuesWithoutCurrent].concat(value))
        } else {
            onValueChanged(valuesWithoutCurrent)
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.code === 'Space' || e.key === ' ') {
            e.preventDefault()
            handleChangeEvent(!isChecked)
        }
    }

    return (
        <>
            <StyledSearchFilterSelect
                as="label"
                key={name}
                data-testid={`${name}-container`}
                onKeyDown={handleKeyDown}
                tabIndex={0}
                htmlFor={`${name}-checkbox`}
                $hasDescription={option?.description !== null}
            >
                <StyledLabelAndIconContainer>
                    {isColourFilter ? (
                        <StyledColourIcon data-testid={`${name}-colour`} colourGradient={colourGradient} />
                    ) : null}
                    <StyledSearchFilterSelectLabel as="span">
                        {`${option?.label || title}`}
                    </StyledSearchFilterSelectLabel>
                </StyledLabelAndIconContainer>
                <StyledSelectionContainer>
                    {count == null || hideCount ? null : (
                        <StyledSearchFilterSelectLabelCount as="span">
                            {count.toLocaleString()}
                        </StyledSearchFilterSelectLabelCount>
                    )}
                    <StyledCheckBoxElement
                        ref={checkboxRef}
                        name={`${name}-checkbox`}
                        id={`${name}-checkbox`}
                        className={`${name}-checkbox`}
                        label={''}
                        secondary={invertColours}
                        checked={isChecked}
                        onChange={(e) => {
                            const { checked } = e.target
                            handleChangeEvent(checked)
                        }}
                    />
                </StyledSelectionContainer>
            </StyledSearchFilterSelect>
            {option?.description ? (
                <StyledSearchFilterDescription as="span">{option?.description}</StyledSearchFilterDescription>
            ) : null}
        </>
    )
}
